var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-group2",
    transform: "translate(-92.000000, -424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-group3",
    transform: "translate(92.000000, 424.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "excel-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2162162,25.5255255 L28.2162162,6.69069069 C28.2162162,5.21081081 27.0054054,4 25.5255255,4 L6.69069069,4 C5.21081081,4 4,5.21081081 4,6.69069069 L4,25.5255255 C4,27.0054054 5.21081081,28.2162162 6.69069069,28.2162162 L25.5255255,28.2162162 C27.0054054,28.2162162 28.2162162,27.0054054 28.2162162,25.5255255 Z",
    id: "excel-icon-path1",
    fill: "#323949",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "excel-icon-polygon1",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "14.1331115 13.1295736 10 13.1295736 10 10 22 10 22 13.1295736 17.8469218 13.1295736 17.8469218 23.4301071 14.1331115 23.4301071"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text-icon.f9fbc205.svg";
export { ForwardRef as ReactComponent };